import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { Observable, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { getGamificationProfileAction } from '../../shared/actions/gamification.actions';
import { GamificationService } from '../../shared/gamification.service';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import {
  getGamificationProfileSelector,
  getLeaderboardSelector,
  getLeaderboardStatusSelector, getWeeklyBadgesSelector
} from '../../shared/reducers/gamification-selectors';
import { AppState } from '../../shared/reducers/index.tx';
import { GamificationBadgeDto } from '../../shared/types/GamificationBadgeDto';
import { GamificationLeaderboardDto } from '../../shared/types/GamificationLeaderboardDto';
import { GamificationLeagueDto } from '../../shared/types/GamificationLeagueDto';
import { GamificationProfileDto } from '../../shared/types/GamificationProfileDto';
import { GamificationSettingsDto } from '../../shared/types/GamificationSettingsDto';
import { LeaderboardStatusType } from '../../shared/types/leaderboard-status-type';
import { LevelProgressDto } from '../../shared/types/LevelProgressDto';
import { LpConstants } from '../../shared/types/lp-constants';
import { UtilsService } from '../../shared/utils.service';
import { LevelSelectionService } from '../../shared/level-selection.service';

@Component({
  selector: 'lp2-study-bundle-progress-v2',
  templateUrl: './study-bundle-progress-v2.component.html',
  styleUrls: ['./study-bundle-progress-v2.component.scss'],
})
export class StudyBundleProgressV2Component implements OnInit, OnDestroy {
  levelProgress: LevelProgressDto;

  leaderboardStatusType = LeaderboardStatusType;

  leaderboardStatus: LeaderboardStatusType;

  leaderboardData$: Observable<GamificationLeaderboardDto>;

  leagues: GamificationLeagueDto[];

  studentLevel: number;

  isLevelExamReady = false;

  contactId = this.oeAppPersonService.contactId;

  gamificationProfile$: Observable<GamificationProfileDto>;

  activityBadge$: Observable<GamificationBadgeDto>;

  gamificationSettings$: Observable<GamificationSettingsDto>;

  destroy = new Subject<boolean>();

  public showLevelSelectionButton = this.oeAppPersonService.showLevelSelectionButton;

  constructor(
    private levelProgressService: LevelProgressService,
    private gamificationService: GamificationService,
    private oeAppPersonService: OeAppPersonService,
    private store: Store<AppState>,
    private levelSelectionService: LevelSelectionService
  ) { }

  ngOnInit() {
    this.levelProgressService.levelProgress$
      .pipe(takeUntil(this.destroy),filter((UtilsService.isNotNull)))
      .subscribe((levelProgress) => {
        {
          this.studentLevel = +levelProgress.levelNumber;
        this.isLevelExamReady = levelProgress.showLevelTest;
        this.levelProgress = levelProgress;
        }
      });

    // Hide the title bar if gamification
    UtilsService.removeTitleMenu();

    this.initGamification();

    this.gamificationProfile$ = this.store.pipe(
      select(getGamificationProfileSelector)
    );

    this.store
      .pipe(select(getLeaderboardStatusSelector), takeUntil(this.destroy))
      .subscribe(
        (data: LeaderboardStatusType) => (this.leaderboardStatus = data)
      );

    this.leaderboardData$ = this.store.pipe(select(getLeaderboardSelector));

    this.activityBadge$ = this.store.pipe(
      select(getWeeklyBadgesSelector),
      map((data: GamificationBadgeDto[]) => (data ? data[0] : null))
    );

    this.gamificationService
      .getLeagues()
      .subscribe((data: GamificationLeagueDto[]) => (this.leagues = data));

    this.gamificationService.startRefreshGamification();

    this.gamificationSettings$ = this.gamificationService.getSettings();
  }

  initGamification() {
    this.store.dispatch(getGamificationProfileAction());
  }

  ngOnDestroy() {
    this.destroy.next(true);
    this.destroy.unsubscribe();

    this.gamificationService.stopRefreshGamification();
  }

  onEOLButtonPress() {
    window.location.href = '/level-exam.html'
  }

  onChangeLevelButtonPress() {
    this.levelSelectionService.openChangeLevelModal();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/study-bundle-progress-v2/study-bundle-progress-v2.component.ts